import React, {useRef, useState, useMemo} from "react";
import {catalogPageProps} from "./type";
import {Accordion, AccordionItem} from "@szhsin/react-accordion";
import {Input} from "../../Components/Input/Input";
import {Button} from "../../Components/Button/Button";
import {CheckBoxGroup, CheckBoxSingle} from "../../Modules/CheckBoxGroup/CheckBoxGroup";
import {Cart} from "../../Components/Cart/Cart";
//
// Ви можете не мати цього типу, тому я прибрав {ItemsProps}
// import {ItemsProps} from "../../Data/Items/Items";
//
import {Option, Selector} from "../../Components/Selector/Selector";
import {BannerFirm} from "../../Modules/BannerFirm/BannerFirm";
import BannerFirms from "../../Data/BannerFirm/FirmBanner";

interface IcheckedGroup {
    [T:string]: string[]
}
export const CatalogPage:React.FC<catalogPageProps> = (props) => {
    const {
        item,
        filter,
    } = props;
    const [items, setItems] = useState(item);
    const InpFrom = useRef<HTMLInputElement>(null);
    const InpTo = useRef<HTMLInputElement>(null);
    const [availableChecked, setAvailableChecked] = useState(false);
    const [sale, setSale] = useState(false);
    const [visibilitySidebar, setVisibilitySidebar] = useState(false);
    const [sortBy, setSortBy] = useState<string | null>(null);

    const {
        uniqueCategories,
        uniqueProcessorCategories,
        uniqueRamCategories,
        uniqueTypeRamCategories,
        uniqueGraphicCategories
    } = useMemo(() => {
        const categories = Array.from(new Set(item?.map(cat => cat?.subcategory || "")));
        const processors = Array.from(new Set(item?.map(cat => cat?.description[0].processor || "")));
        const rams = Array.from(new Set(item?.map(cat => cat?.description[0].ram || "")));
        const typeRams = Array.from(new Set(item?.map(cat => cat?.description[0].typeRam || "")));
        const graphics = Array.from(new Set(item?.map(cat => cat?.description[0].graphic || "")));

        return {
            uniqueCategories: categories,
            uniqueProcessorCategories: processors,
            uniqueRamCategories: rams,
            uniqueTypeRamCategories: typeRams,
            uniqueGraphicCategories: graphics
        };
    }, [item]);

    const checkProcessorGroupOption = {
        processor: uniqueProcessorCategories,
    }
    const checkRamGroupOption = {
        Ram: uniqueRamCategories,
    }
    const checkTypeRamGroupOption = {
        typeRam: uniqueTypeRamCategories,
    }
    const checkGraphicGroupOption = {
        graphic: uniqueGraphicCategories,
    }
    const checkGroupOption = {
        category: uniqueCategories,
    };

    const [checkedBoxByGroup, setIsCheckedBoxByGroup] = useState<IcheckedGroup>({
    });

    const option:Option[] = [
        {
            label: "Price Low - High",
            value: "priceLowToHigh"
        },
        {
            label: "Price High - Low",
            value: "priceHighToLow"
        },
        {
            label: "Model A - Z",
            value: "alphabeticalZToA"
        },
        {
            label: "Model Z - A",
            value: "alphabeticalAToZ"
        },
    ]

    const handleApplyFilters = () => {
        let filteredItems = item ? [...item] : [];

        const priceFrom = InpFrom.current ? parseFloat(InpFrom.current.value) : 0;
        const priceTo = InpTo.current ? parseFloat(InpTo.current.value) : Infinity;

        if (!isNaN(priceFrom) && priceFrom > 0) {
            filteredItems = filteredItems.filter(item => (item.price || 0) >= priceFrom);
        }
        if (!isNaN(priceTo) && priceTo > 0 && priceTo > priceFrom) {
            filteredItems = filteredItems.filter(item => (item.price || 0) <= priceTo);
        }

        if (availableChecked) {
            filteredItems = filteredItems.filter(item => item.availability);
        }
        if (sale) {
            filteredItems = filteredItems.filter(item => item.sale !== null);
        }

        if (checkedBoxByGroup.category && checkedBoxByGroup.category.length > 0) {
            filteredItems = filteredItems.filter(item => checkedBoxByGroup.category.includes(item.subcategory || ''));
        }
        if (checkedBoxByGroup.graphic && checkedBoxByGroup.graphic.length > 0) {
            filteredItems = filteredItems.filter(item =>
                checkedBoxByGroup.graphic.includes(item.description[0].graphic || '')
            );
        }
        if (checkedBoxByGroup.processor && checkedBoxByGroup.processor.length > 0) {
            filteredItems = filteredItems.filter(item =>
                checkedBoxByGroup.processor.includes(item.description[0].processor || '')
            );
        }
        if (checkedBoxByGroup.ram && checkedBoxByGroup.ram.length > 0) {
            filteredItems = filteredItems.filter(item =>
                checkedBoxByGroup.ram.includes(item.description[0].ram || '')
            );
        }
        if (checkedBoxByGroup.typeRam && checkedBoxByGroup.typeRam.length > 0) {
            filteredItems = filteredItems.filter(item =>
                checkedBoxByGroup.typeRam.includes(item.description[0].typeRam || '')
            );
        }

        if (sortBy) {
            filteredItems.sort((a, b) => {
                switch (sortBy) {
                    case 'priceLowToHigh': return (a.price || 0) - (b.price || 0);
                    case 'priceHighToLow': return (b.price || 0) - (a.price || 0);
                    case 'alphabeticalAToZ': return (a.model || '').localeCompare(b.model || '');
                    case 'alphabeticalZToA': return (b.model || '').localeCompare(a.model || '');
                    default: return 0;
                }
            });
        }

        setItems(filteredItems);
    };

    const handleClearFilters = () => {
        setIsCheckedBoxByGroup({});
        setItems(item);
        setAvailableChecked(false);
        setSale(false);
        setSortBy(null);


        if (InpFrom.current) InpFrom.current.value = '';
        if (InpTo.current) InpTo.current.value = '';
    };

    const sortItems = (sortByValue: 'priceLowToHigh' | 'priceHighToLow' | 'alphabeticalAToZ' | 'alphabeticalZToA') => {
        setSortBy(sortByValue);

        const sortedItems = [...items || []];

        sortedItems.sort((a, b) => {
            switch (sortByValue) {
                case 'priceLowToHigh': return (a.price || 0) - (b.price || 0);
                case 'priceHighToLow': return (b.price || 0) - (a.price || 0);
                case 'alphabeticalAToZ': return (a.model || '').localeCompare(b.model || '');
                case 'alphabeticalZToA': return (b.model || '').localeCompare(a.model || '');
                default: return 0;
            }
        });

        setItems(sortedItems);
    };

    const handleCheckedBoxGroup = (event: React.ChangeEvent<HTMLInputElement>, nameGroup: string) => {
        setIsCheckedBoxByGroup((prevState) => {
            const updatedState = { ...prevState };

            if (event.target.checked) {
                if (updatedState[nameGroup]?.includes(event.target.value)) {
                    return prevState;
                } else {
                    updatedState[nameGroup] = [...(updatedState[nameGroup] || []), event.target.value];
                }
            } else {
                updatedState[nameGroup] = updatedState[nameGroup]?.filter(x => x !== event.target.value) || [];
            }

            return updatedState;
        });
    };

    const handleAvailabilityChange = (isChecked: boolean) => {
        setAvailableChecked(isChecked);
    }

    const handleSaleChange = (isChecked:boolean) => {
        setSale(isChecked)
    }
    const handleVisibilitySidebar = () => {
        setVisibilitySidebar(!visibilitySidebar)
    }
    const accordionClass = visibilitySidebar ? 'block fixed top-0 left-0 max-w-full max-h-full w-full z-50 bg-white' : 'hidden';

    return (
        <section className={"py-8 max-sm:py-2"}>
            <div className="container">
                <h1 className={"font-bold text-3xl max-sm:text-center"}>
                    {filter ? filter : "Catalog"}
                </h1>

                <div className={"grid grid-cols-[200px_1fr] mt-6 gap-5 max-md:grid-cols-1"}>
                    {/*sidebar*/}
                    <div>
                        <Accordion allowMultiple className={`max-w-52 h-fit border border-grey 
                    max-md:${accordionClass}`
                        }>
                            {visibilitySidebar && <div className={"flex justify-between items-center p-3"}>
                                <p>Filter product</p>
                                <Button isDisabled={true} className={"border-none text-black"} onClick={handleVisibilitySidebar} title={"X"}/>
                            </div>
                            }

                            <AccordionItem
                                header={
                                    <p className={"text-base font-medium hover:text-red"}>
                                        Cena
                                    </p>
                                } initialEntered className={"p-2 border border-b-grey"}>
                                <div className={"flex items-center justify-center gap-2"}>
                                    <Input type={'text'}
                                           placeholder={'od'}
                                           className={'py-1 px-1 text-xs rounded-none border-grey'}
                                           inputRef={InpFrom}
                                    />
                                    <p>
                                        -
                                    </p>
                                    <Input type={'text'}
                                           placeholder={'do'}
                                           className={'py-1 px-1 text-xs rounded-none border-grey'}
                                           inputRef={InpTo}
                                    />
                                </div>
                            </AccordionItem>

                            <AccordionItem
                                header={
                                    <p className={"text-base font-medium hover:text-red"}>
                                        Availability
                                    </p>
                                } initialEntered className={"p-2 border border-b-grey"}>

                                <CheckBoxSingle label={'Availability'}
                                                id={'available'}
                                                className={'text-sl pl-2 hover:underline'}
                                                isChecked={availableChecked}
                                                onChange={handleAvailabilityChange}
                                />

                            </AccordionItem>

                            <AccordionItem header={
                                <p className={"text-base font-medium hover:text-red"}>
                                    Sale
                                </p> } initialEntered className={"p-2 border border-b-grey"}>

                                <CheckBoxSingle
                                    label={'Sale'}
                                    id={'sale'}
                                    className={'text-sl pl-2 hover:underline'}
                                    isChecked={sale}
                                    onChange={handleSaleChange}
                                />
                            </AccordionItem>

                            <AccordionItem header={
                                <p className={"text-base font-medium hover:text-red"}>
                                    Category
                                </p>
                            } className={"p-2 border border-b-grey"}>
                                {checkGroupOption.category.map(label => (
                                    <CheckBoxGroup
                                        className={'text-sl pl-2 hover:underline'}
                                        checkedBoxesByGroup={checkedBoxByGroup}
                                        id={label}
                                        key={label}
                                        nameGroup={"category"}
                                        label={label}
                                        onChange={handleCheckedBoxGroup}
                                    />
                                ))}
                            </AccordionItem>

                            <AccordionItem header={
                                <p className={"text-base font-medium hover:text-red"}>
                                    Cart Graphics
                                </p>
                            } className={"p-2 border border-b-grey"}>
                                {checkGraphicGroupOption.graphic.map(label => (
                                    <CheckBoxGroup
                                        checkedBoxesByGroup={checkedBoxByGroup}
                                        className={'text-sl pl-2 hover:underline'}
                                        id={label}
                                        key={label}
                                        nameGroup={"graphic"}
                                        label={label}
                                        onChange={handleCheckedBoxGroup}
                                    />
                                ))}
                            </AccordionItem>

                            <AccordionItem header={
                                <p className={"text-base font-medium hover:text-red"}>
                                    Processor
                                </p>
                            } className={"p-2 border border-b-grey"}>
                                {checkProcessorGroupOption.processor.map(label => (
                                    <CheckBoxGroup
                                        checkedBoxesByGroup={checkedBoxByGroup}
                                        id={label}
                                        className={'text-sl pl-2 hover:underline'}
                                        key={label}
                                        nameGroup={"processor"}
                                        label={label}
                                        onChange={handleCheckedBoxGroup}
                                    />
                                ))}
                            </AccordionItem>

                            <AccordionItem header={
                                <p className={"text-base font-medium hover:text-red"}>
                                    Memories RAM
                                </p>
                            } className={"p-2 border border-b-grey"}>
                                {checkRamGroupOption.Ram.map(label => (
                                    <CheckBoxGroup
                                        checkedBoxesByGroup={checkedBoxByGroup}
                                        id={label}
                                        className={'text-sl pl-2'}
                                        key={label}
                                        nameGroup={"ram"}
                                        label={label}
                                        onChange={handleCheckedBoxGroup}
                                    />
                                ))}
                            </AccordionItem>

                            <AccordionItem header={
                                <p className={"text-base font-medium hover:text-red"}>
                                    Typ memories RAM
                                </p>
                            } className={"p-2 border border-b-grey"}>
                                {checkTypeRamGroupOption.typeRam.map(label => (
                                    <CheckBoxGroup
                                        checkedBoxesByGroup={checkedBoxByGroup}
                                        id={label}
                                        className={'text-sl pl-2'}
                                        key={label}
                                        nameGroup={'typeRam'}
                                        label={label}
                                        onChange={handleCheckedBoxGroup}
                                    />
                                ))}
                            </AccordionItem>
                            <div className={"flex items-center justify-center flex-col gap pt-5 "}>
                                <Button title={"Apply filter"} onClick={handleApplyFilters} isDisabled={true} className={"hover:bg-blue hover:text-white"} />
                                <Button title={'Clear filter'}
                                        onClick={handleClearFilters}
                                        isDisabled={true}
                                        className={"border-transparent text-grey hover:bg-transparent hover:text-red hover:underline"}/>
                            </div>
                        </Accordion>

                        <BannerFirm banners={BannerFirms} classNameImg={'max-w-16'}/>
                    </div>

                    {/*row content*/}
                    <div>
                        <div className={"flex justify-between"}>
                            <Selector
                                placeholder={"Sort by:"}
                                options={option}
                                className={"w-full"}
                                onChange={(selection: Option) => sortItems(selection.value as any)}
                            />
                            <Button title={"filter"}
                                    className={"hidden max-w-52 w-full border rounded-none border-gray text-black cursor-pointer max-md:block"}
                                    isDisabled={true}
                                    onClick={handleVisibilitySidebar}
                            />
                        </div>
                        {items && items.length > 0 ? (
                            <div className="grid grid-cols-5 max-md:grid-cols-4 max-sm:grid-cols-2">
                                {items.map(item => (
                                    <Cart item={item} key={item.id}/>
                                ))}
                            </div>
                        ) : (
                            <div className={"grid grid-cols-5"}>
                                <p>No items found....</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    )
}